// Don't use the Node.js Cloudinary import in the browser
// import { v2 as cloudinary } from 'cloudinary';

// Browser-safe Cloudinary upload functions
/**
 * Uploads a video file to Cloudinary
 * @param file The file to upload (from an input element)
 * @returns The uploaded video URL
 */
export const uploadVideo = async (file: File): Promise<string> => {
  return new Promise((resolve, reject) => {
    // Create a form data object to send to Cloudinary
    const formData = new FormData();
    formData.append('file', file);
    formData.append('upload_preset', import.meta.env.VITE_CLOUDINARY_UPLOAD_PRESET || 'rion-safaris'); // Use environment variable or fallback
    formData.append('resource_type', 'video');
    
    // Use Cloudinary's upload endpoint directly
    fetch(`https://api.cloudinary.com/v1_1/${import.meta.env.VITE_CLOUDINARY_CLOUD_NAME || 'dik2mqn3b'}/video/upload`, {
      method: 'POST',
      body: formData,
    })
      .then(response => response.json())
      .then(data => {
        if (data.secure_url) {
          resolve(data.secure_url);
        } else {
          reject(new Error('Failed to get upload URL'));
        }
      })
      .catch(error => {
        console.error('Cloudinary upload error:', error);
        reject(error);
      });
  });
};

/**
 * Uploads an image file to Cloudinary
 * @param file The file to upload (from an input element)
 * @returns The uploaded image URL
 */
export const uploadImage = async (file: File): Promise<string> => {
  return new Promise((resolve, reject) => {
    // Create a form data object to send to Cloudinary
    const formData = new FormData();
    formData.append('file', file);
    formData.append('upload_preset', import.meta.env.VITE_CLOUDINARY_UPLOAD_PRESET || 'rion-safaris'); // Use environment variable or fallback
    
    // Use Cloudinary's upload endpoint directly
    fetch(`https://api.cloudinary.com/v1_1/${import.meta.env.VITE_CLOUDINARY_CLOUD_NAME || 'dik2mqn3b'}/image/upload`, {
      method: 'POST',
      body: formData,
    })
      .then(response => response.json())
      .then(data => {
        if (data.secure_url) {
          resolve(data.secure_url);
        } else {
          reject(new Error('Failed to get upload URL'));
        }
      })
      .catch(error => {
        console.error('Cloudinary upload error:', error);
        reject(error);
      });
  });
}; 